import * as SendBird from 'sendbird';
import * as shortid from 'shortid';

export default class SendBirdChatEvent {
  public onMessageReceived: SendBird.ChannelHandler['onMessageReceived'] | null = null;
  public onMessageUpdated: SendBird.ChannelHandler['onMessageUpdated'] | null = null;
  public onMessageDeleted: SendBird.ChannelHandler['onMessageDeleted'] | null = null;

  private _sb = SendBird.getInstance();
  private _key = shortid.generate();

  constructor() {
    this._createChannelHandler();
  }

  public remove() {
    this._sb.removeChannelHandler(this._key);
  }

  /**
   * Channel Handler
   */
  private _createChannelHandler() {
    const handler = new this._sb.ChannelHandler();

    handler.onMessageReceived = (channel, message) => {
      if (this.onMessageReceived) {
        this.onMessageReceived(channel, message);
      }
    };

    handler.onMessageUpdated = (channel, message) => {
      if (this.onMessageUpdated) {
        this.onMessageUpdated(channel, message);
      }
    };

    handler.onMessageDeleted = (channel, messageId) => {
      if (this.onMessageDeleted) {
        this.onMessageDeleted(channel, messageId);
      }
    };

    this._sb.addChannelHandler(this._key, handler);
  }
}



// WEBPACK FOOTER //
// ./src/services/sb/SendBirdChatEvent.ts